<div class="loader" *ngIf="loading">
    <mat-spinner [diameter]="150"></mat-spinner>
  </div>
<div class="container">
    <form [formGroup]="resetPasswordFormGroup" class="register-form" >
      <fieldset [disabled]="loading" class="fieldset">
        <mat-form-field class="full-input-grid senha" appearance="outline">
          <mat-label>{{ 'signUp.password' | translate }}</mat-label>
          <input data-test="campo-nova-senha" type="password" matInput formControlName="password" autocomplete="new-password" onPaste="return false" (keypress)="justOneSpecialCharacter($event, 'password')">
          <mat-error *ngIf="form['password'].invalid && !form['password'].hasError('pattern')">{{message.errorMessage(form['password'])}}</mat-error>
          <mat-error *ngIf="form['password'].invalid && form['password'].hasError('pattern')">
            <ul>
              {{ 'signUp.passwordValidationHeader' | translate }}
              <li>{{ 'signUp.passwordValidationFirstItem' | translate }}</li>
              <li>{{ 'signUp.passwordValidationSecondItem' | translate }}</li>
              <li>{{ 'signUp.passwordValidationThridItem' | translate }}</li>
              <li>{{ 'signUp.passwordValidationFourthItem' | translate }}</li>
              <li>{{ 'signUp.passwordValidationFifthItem' | translate }}</li>
              <br />
              {{ 'signUp.passwordValidationFooter' | translate }}
            </ul>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="full-input-grid" appearance="outline">
          <mat-label>{{ 'signUp.confirmPassword' | translate }}</mat-label>
          <input data-test="campo-confirmar-nova-senha" type="password" matInput formControlName="repeatedPassword" autocomplete="new-password" onPaste="return false">
          <mat-error *ngIf="form['repeatedPassword'].invalid && !form['repeatedPassword'].hasError('notSame')">{{message.errorMessage(form['repeatedPassword'])}}</mat-error>
          <mat-error *ngIf="form['repeatedPassword'].invalid && form['repeatedPassword'].hasError('notSame')">Senhas não conferem</mat-error>
        </mat-form-field>
        <div>
            <a data-test="link-voltar-login" class="redirect-link" routerLink="/sign-in">{{ 'forgotPassword.message' | translate }}</a>
            <button data-test="btn-alterar-senha" class="full-input-grid button" mat-raised-button color="primary" (click)="changePassword()">{{ 'forgotPassword.button' | translate }}</button>
        </div>
      </fieldset>
    </form>
</div>